<div class="container-margin">
  <h1 class="header">{{ title }}</h1>

  <form [formGroup]="templateForm">
    <div class="form-groups">
      <div class="form-group template-name">
        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getCsvTemplateNameText()
          }}</mat-label>
          <input
            matInput
            type="text"
            name="templateName"
            formControlName="templateName"
            autocomplete="off"
            maxlength="36"
            required
          />
        </mat-form-field>
      </div>

      <div class="info-text form-group">
        <p>{{ translationService.getFieldMappingPromptText() }}</p>
      </div>

      <div class="form-group">
        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getProductIdentifierText()
          }}</mat-label>
          <input
            matInput
            type="text"
            name="productIdentifier"
            formControlName="productIdentifier"
            autocomplete="off"
            maxlength="36"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ translationService.getCompanyNameText() }}</mat-label>
          <input
            matInput
            type="text"
            name="companyName"
            formControlName="companyName"
            autocomplete="off"
            maxlength="36"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getOverrideProductSupplierText()
          }}</mat-label>
          <input
            matInput
            type="text"
            name="overrideProductSupplier"
            formControlName="overrideProductSupplier"
            autocomplete="off"
            maxlength="36"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getOverrideComponentSuppliersText()
          }}</mat-label>
          <input
            matInput
            type="text"
            name="overrideComponentSuppliers"
            formControlName="overrideComponentSuppliers"
            autocomplete="off"
            maxlength="36"
            required
          />
        </mat-form-field>
      </div>
    </div>

    <div class="actions">
      <button
        mat-raised-button
        extended
        color="primary"
        class="action-item"
        type="button"
        (click)="onSubmit()"
      >
        <mat-icon>add</mat-icon>
        {{ translationService.getSubmitText() }}
      </button>

      <button
        type="button"
        mat-stroked-button
        extended
        color="primary"
        class="action-item"
        (click)="onReset()"
      >
        <mat-icon>refresh</mat-icon>
        {{ translationService.getResetText() }}
      </button>
    </div>
  </form>
</div>
